var $ = jQuery = require('jquery');
var bootstrap = require('bootstrap');
var lightbox = require('lightbox');
var imagesLoaded = require('imagesLoaded');
var masonry = require('masonry');

$(function () {
    var resizeBlocks = function () {
        if ($(window).width() >= 992) {
            $('.equal-heights').each(function () {
                var equalizeEls = $(this).find('.equalize');
                var maxHeight = 0;
                var curHeight = 0;

                if (equalizeEls.length >= 2) {
                    $(this).find('.equalize').each(function () {
                        $(this).removeAttr('style');
                        curHeight = $(this).height();

                        if (curHeight > maxHeight) {
                            maxHeight = curHeight;
                        }
                    });

                    $(this).find('.equalize').height(maxHeight);
                }
            });
        } else {
            $('.equal-heights .equalize').removeAttr('style');
        }
    };

    window.addEventListener('resize', function () {
        resizeBlocks();
    });

    resizeBlocks();


    // populate the default item varient
    $('#product-detail-v2 .product-group-name').html($('#product-detail-v2 [data-item-varient-option].active a').html())

    // toggle item variant that is shown on the item detail page
    $('#product-detail-v2 [data-item-varient-option]').click(function (e) {
        e.preventDefault();
        $('#product-detail-v2 [data-item-varient-option]').removeClass('active');
        $(this).addClass('active');
        $('#product-detail-v2 .product-group-name').html($('#product-detail-v2 [data-item-varient-option].active span').html())
        $('[data-item-variant]').hide();
        $('[data-item-variant="' + $(this).parent().find('.active').data('item-varient-option') + '"]').show();
        $('#product-datasheet-btn').attr('href', '/datasheet?lotkey=' + $('[data-item-variant="' + $(this).parent().find('.active').data('item-varient-option') + '"] .lot-detail.active').data('lot-key') + '&format=pdf');
        $('#product-quote-btn').attr('href', '/request-a-quote?lot=' + $('[data-item-variant="' + $(this).parent().find('.active').data('item-varient-option') + '"] .lot-detail.active').data('lot-key'));
        resizeBlocks();
    });

    // initialize tooltips
    $('[data-toggle="tooltip"]').tooltip({
        delay: { "show": 0, "hide": 2000 }
    });
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });

    // handle blog comments
    $('.show-blog-comments').click(function (e) {
        e.preventDefault();
        $('.blog-comments').show();
        $('.show-blog-comments').hide();
    });

    // masonry grid
    if ($('.masonry-grid').length > 0) {
        imagesLoaded($('.masonry-grid')[0], function () {
            new masonry('.masonry-grid', {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true
            });
        });
    }

    // find a fabricator
    if ($('.find-a-fab-wrapper').width() < 960) {
        $('.find-a-fab-inner').css('transform', 'scale(' + $('.find-a-fab-wrapper').width()/960 + ')');
    }
    $(window).resize(function () {
        if ($('.find-a-fab-wrapper').width() < 960) {
            $('.find-a-fab-inner').css('transform', 'scale(' + $('.find-a-fab-wrapper').width() / 960 + ')');
        } else {
            $('.find-a-fab-inner').css('transform', 'none');
        }
    });

    // shrinking header subnav
    $(window).scroll(function() {
        if ($(window).scrollTop() > 50) {
            $('#header-nav').addClass('shrink');
            $('#header-nav .utility-nav').addClass('shrink');
            if ($('#personalized-topbar-pushdown')) {
                $('#personalized-topbar-pushdown').addClass('shrink');
            }
        } else {
            $('#header-nav').removeClass('shrink');
            $('#header-nav .utility-nav').removeClass('shrink');
            if ($('#personalized-topbar-pushdown')) {
                $('#personalized-topbar-pushdown').removeClass('shrink');
            }
        }
    });

    // set inital active lot buttons
    $('#product-datasheet-btn').attr('href', '/datasheet?lotkey=' + $('.lot-detail.active').first().data('lot-key') + '&format=pdf');
    $('#product-quote-btn').attr('href', '/request-a-quote?lot=' + $('.lot-detail.active').first().data('lot-key'));

    // hide carousel arrows on first and last, populate active lot
    $('.carousel.lot-image-carousel').on('slid.bs.carousel', function () {
        var slideCount = $(this).find('.item').length;
        var slideIndex = $(this).find('.item.active').index();
        var slidePrevControl = $(this).find('[data-slide=prev]');
        var slideNextControl = $(this).find('[data-slide=next]');

        // show / hide controls if needed
        if (slideIndex === 0) {
            slidePrevControl.hide();
        } else {
            slidePrevControl.show();
        }

        if (slideIndex + 1 === slideCount) {
            slideNextControl.hide();
        } else {
            slideNextControl.show();
        }

        $('table[data-item-ext-desc=' + $(this).data('item-ext-desc') + '] .lot-item').removeClass('active-row');
        $('table[data-item-ext-desc=' + $(this).data('item-ext-desc') + '] .lot-item:nth-child(' + (slideIndex + 1) + ')').addClass('active-row');

        $('.lot-preview-container[data-item-ext-desc=' + $(this).data('item-ext-desc') + '] .lot-preview').removeClass('active-preview');
        $('.lot-preview-container[data-item-ext-desc=' + $(this).data('item-ext-desc') + '] .lot-preview:nth-child(' + (slideIndex + 1) + ')').addClass('active-preview');


        $('#product-datasheet-btn').attr('href', '/datasheet?lotkey=' + $(this).find('.lot-detail.active').data('lot-key') + '&format=pdf');
        $('#product-quote-btn').attr('href', '/request-a-quote?lot=' + $(this).find('.lot-detail.active').data('lot-key'));
    });

    // slide carousel to specific slide
    $('.lot-preview-inner').click(function() {
        $('[data-item-ext-desc="' + $(this).parent().parent().data('item-ext-desc') + '"]').carousel($(this).parent().index());
    });

    // hide next arrow if carousel only has 1 slide
    $('.carousel.lot-image-carousel').each(function () {
        if ($(this).find('.item').length === 1) {
            $(this).find('[data-slide=next]').hide();
        }
    });

    if ($('.EditingFormErrorLabel').length > 0) {
        window.scrollTo(0, $('.EditingFormErrorLabel').first().closest('.FormPanel').first().parent().offset().top - 100);
    }

});

// stripe form
$(function () {

    if ($('.stripe-form').length > 0) {
        // prevent users from pressing enter to submit
        $(window).keydown(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                return false;
            }
        });

        // hide submit button
        $('input[type=submit]').hide();

        // handle submission to stripe
        $('#stripeSubmit').click(function (e) {
            e.preventDefault();
            var $form = $(this);

            $form.find('#lblError').hide();

            // Disable the submit button to prevent repeated clicks
            $form.find('input[type=submit]').attr('disabled', true);

            Stripe.card.createToken({
                number: $('#stripeNumber').val(),
                cvc: $('#stripeCvc').val(),
                exp_month: $('#stripeMonth').val(),
                exp_year: $('#stripeYear').val()
            }, function (status, response) {
                var $form = $('form');

                if (response.error) {
                    $form.find('#lblError').show().text(response.error.message);
                } else {
                    $('#lblError').hide().text('');
                    // token contains id, last4, and card type
                    var token = response.id;
                    // Insert the token into the form so it gets submitted to the server
                    $form.find('#stripeToken').val(token);

                    $('#stripeSubmit').hide();

                    // execute the js in the onlcick attribute for the form submit button
                    if (typeof ($('input[type=submit]')[0]['onclick']) === 'function') {
                        $('input[type=submit]')[0]['onclick'].call($('input[type=submit]')[0]);
                    } else {
                        $('input[type=submit]')[0].click();
                    };
                }
            });
        });
    }
});

$(function () {
    $('#fabricator-search-zip').keypress(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();

            if ($(this).val().length === 5) {
                window.location.href = window.location.origin + window.location.pathname + "?zip=" + $(this).val();
            }
        }
    });
})
